import React from 'react'
import Icon from './Icon'

const Edit = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="M20.46 25.247l-.323 1.616 1.616-.323 4.98-4.98a.904.904 0 0 0 .267-.644.903.903 0 0 0-.267-.643.914.914 0 0 0-1.293-.006l-4.98 4.98zM22 27h.01H22zm-2.5 1a.499.499 0 0 1-.49-.598l.5-2.5a.506.506 0 0 1 .136-.255l5.087-5.087a1.911 1.911 0 0 1 2.701 0A1.9 1.9 0 0 1 28 20.916c0 .51-.199.99-.56 1.35l-5.087 5.088a.506.506 0 0 1-.255.137l-2.5.5A.55.55 0 0 1 19.5 28zm-2-2h-4c-.827 0-1.5-.673-1.5-1.5v-11c0-.827.673-1.5 1.5-1.5h7.086c.401 0 .778.156 1.061.44l1.914 1.914c.283.283.439.66.439 1.06V17.5a.5.5 0 0 1-1 0v-2.086a.503.503 0 0 0-.146-.353l-1.915-1.915a.495.495 0 0 0-.353-.146H13.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1z" />
    </g>
  </Icon>
)

export default Edit



// WEBPACK FOOTER //
// ./icons/Edit.js